export const welcomeTextSelector = (state) => state.common.welcomeText;
export const isWelcomeTextLoadingSelector = (state) => state.common.isWelcomeTextLoading;
export const errorSelector = (state) => state.common.error;
export const showMobileMenuSelector = (state) => state.common.showMobileMenu;
